import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FAQ from './FAQ/FAQ';
import './styles.scss';
import { supportPageConstants } from './supportConstants';
import { AnalyticsService } from 'src/Analytics/AnalyticsService';
import { PrimaryButton } from 'office-ui-fabric-react';
import { withRouter } from 'react-router-dom';
import ModalGE from 'src/Components/ModalGE/ModalGE';
import { withTranslation, useTranslation } from 'react-i18next';
import PulseLoader from 'react-spinners/PulseLoader';
import manufacturer from 'src/Assets/Images/manufacturer.svg';
import batchcode from 'src/Assets/Images/batchcode.svg';
import { getNativeAppDownloadUrl } from 'src/Services/Collab/collabService';
import DownloadInitialize from './DownloadInitialize';

export const ContactUs = (props) => {
  let { t } = useTranslation();
  let { isLoading } = props;
  let contacts = props.contacts;
  let contacts_extra = props.contacts_extra;
  contacts = contacts.concat(contacts_extra);
  const renderAnswers = (obj) => {
    let links = obj;

    return (
      links.map((ob) => (
        <span className="number" key={ob.linklabel}
        >
          <a className="phone-number-link"
            href={ob.linkRef}
            target="_blank"
          >
            {ob.linklabel}
          </a>
          <span  className = "phone-number-or" dangerouslySetInnerHTML={{ __html: ob.html }}></span>
        </span>))
    );
  }


  const renderSupportContacts = () => {
    return (
      <>
        {isLoading ? (
          <div></div>) : (contacts &&
            contacts.map((ob, i) => (

              <div className="number-section-wrapper" key={ob.question}>
                <div className="number-for-text" key={ob.question}>
                  {ob.data.label}
                </div>

                <div className="number-icon-container" key={ob.data.links}>
                  <FontAwesomeIcon icon={ob.data.links[0].icon} />
                  {renderAnswers(ob.data.links)}

                </div>
                <hr className="separator" />
              </div>
            ))
        )}</>
    )
  }

  return (
    <>
      {isLoading ? (
        <div></div>) : (
        <div className="contact-us-wrapper">
          <h4 className="contact-us-heading">{t('contactUs')}</h4>
          {renderSupportContacts()}
        </div>
      )}
    </>)
};

export const ContactUsAuthorised = (props) => {
  let { t } = useTranslation();
  let { isLoading } = props;
  let contacts_extra = props.contacts_extra;
  let contacts = props.contacts;

  const renderAnswers = (obj) => { //NOSONAR

    let links = obj;
    return (
      links.map((item) => (
        <span className="number" key={item.linklabel}
        >
          <a className="phone-number-link"
            href={item.linkRef}
            target="_blank"
          >
            {item.linklabel}
          </a>
          <span className = "phone-number-or"dangerouslySetInnerHTML={{ __html: item.html }}></span>
        </span>))
    );
  }


  const renderSupportContacts = () => {

    return (
      <>
        {isLoading ? (
          <div></div>) : (contacts &&
            contacts.map((ob, i) => (

              <div className="number-section-wrapper" key={ob.data.label}>
                <div className="number-for-text" key={ob.question}>
                  {ob.data.label}
                </div>

                <div className="number-icon-container" key={ob.data.links}>
                  <FontAwesomeIcon icon={ob.data.links[0].icon} />
                  {renderAnswers(ob.data.links)}

                </div>
                <div className='qr-text'
                  dangerouslySetInnerHTML={{ __html: ob.data.htmlData }}
                >

                </div>
                <hr className="separator" />
              </div>
            ))
        )}</>
    )
  }

  const renderSupportContacts_extra = () => {
    return (
      <>
        {isLoading ? (
          <div></div>) : (contacts_extra &&
            contacts_extra.map((item) => (

              <div className="number-section-wrapper" key={item.data.links}>
                <div className="number-for-text" key={item.question}>
                  {item.data.label}
                </div>

                <div className="number-icon-container" key={`${i}${i}`}>
                  <FontAwesomeIcon icon={item.data.links[0].icon} />
                  {renderAnswers(item.data.links)}

                </div>
                <div className='qr-text'
                  dangerouslySetInnerHTML={{ __html: item.data.htmlData }}
                >

                </div>
                <hr className="separator" />
              </div>
            ))
        )}</>
    )
  }

  return (
    <>
      {isLoading ? (
        <div></div>) : (
        <div className="contact-us-wrapper">
          <h4 className="contact-us-heading">{t('contactUs')}</h4>
          {renderSupportContacts()}
          {renderSupportContacts_extra()}
        </div>
      )}
    </>)
};

class AboutUnautherizedComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productUpdateslVisible: false,
    };
  }
  handleProductUpdateRedirect = () => {
    if (typeof window['digitalData'] !== 'undefined') {
      window.digitalData.link = {
        linkName: 'Product Update Link',
        linkType: 'About Section',
      };
    }

    AnalyticsService.trackEvent('link_click');
    this.props.history.push('/productUpdate');
  };
  renderAnswers = (obj) => {

    const openLinks = (url, txt) => {
      if (typeof window['digitalData'] !== 'undefined') {
        window.digitalData.link = {
          linkName:
            typeof txt === 'object'
              ? txt?.target?.innerText + ' Link'
              : txt + ' Link',
          linkType: 'About Section',
        };
      }

      AnalyticsService.trackEvent('link_click');
      window.open(url, '_blank');
    };

    let internalRoute = obj[0].isInternalRoute;
    return (

      <span
        className="link"
        id="privacy-link"
        onClick={internalRoute ? this.handleProductUpdateRedirect : openLinks.bind(
          this,
          obj[0].linkRef
        )}
      >{obj[0].linklabel}
      </span>);
  }

  renderAboutData = () => {
    let { aboutDetails } = this.props;
    return (
      <>
        {aboutDetails && aboutDetails.length > 0 && aboutDetails.map((ob) => {

          return (
            <div className="link-container" key={ob.id}>

              {this.renderAnswers(ob.data.links)}
              <hr className="separator" />
            </div>

          )
        })}
        <div></div>
      </>
    );
  }

  render = () => {
    const {
      headingText,
    } = this.props.aboutSection;
    return (

      <div className="about-section-wrapper">
        <h3 className="about-heading">{headingText}</h3>
        {this.renderAboutData()}
      </div>);
  };
}

class AboutComponent extends Component {
  constructor(props) { //NOSONAR
    super(props);
    this.state = {
      productUpdateslVisible: false
    };
  }

  handleProductUpdateRedirect = () => { //NOSONAR
    if (typeof window['digitalData'] !== 'undefined') {
      window.digitalData.link = {
        linkName: 'Product Update Link',
        linkType: 'About Section',
      };
    }

    AnalyticsService.trackEvent('link_click');
    this.props.history.push('/productUpdate');
  };

  handlePreSignedUrl =async() => {
    try{
      const response = await getNativeAppDownloadUrl();
      return response;
    } catch(e){
      console.log(e);
      return null;
    }
  }

  handleDownloadFile = () => {
    const urlArr = this.props.support.downloadUrl.split('?');
    const jsonObj = urlArr[0].substring(urlArr[0].lastIndexOf('/') + 1);
    let fileName = jsonObj;
    if (typeof window['digitalData'] !== 'undefined') {
      if (window.digitalData?.page) {
        window.digitalData.page.DownloadedFileName = fileName;
      }
      else {
        window.digitalData.page = {
          "DownloadedFileName": fileName
        }
      }
      window.digitalData.link = {
        linkName: 'Download Meeting Software',
        linkType: 'About Section',
      };
    }

    AnalyticsService.trackEvent('setAnalyticsVariables');
    AnalyticsService.trackEvent('link_click');

    const link = document.createElement('a');
    link.href = this.props.support.downloadUrl;
    link.setAttribute('download', fileName);
    link.addEventListener('click', () => {
      layerDiv.removeChild(link);
    });
    const layerDiv = document.querySelector('.support-download');
    if (layerDiv) {
      layerDiv.appendChild(link);
    }
    link.click();
    this.props.handleDownloadUrl(null);
  };

  handleDownloadPopUp = async () => {
    const downloadStage = {downloadModal: true, downloadError: null, downloadInitializing: true, downloadStarted: false };

    await this.props.handleDownloadModal(downloadStage);
    const downloadRes = await this.handlePreSignedUrl();

    if (downloadRes && downloadRes.data) {

      const { aboutSection } = this.props;
      const res = downloadRes.data;
      
      switch (res.status) {
          case aboutSection.downloadAvailable.toString():
              if(res.software && res.software.downloadUrl){
                await this.props.handleDownloadUrl(res.software.downloadUrl);
                this.handleDownloadFile();
                downloadStage.downloadStarted = true;
                setTimeout(this.closeSubmittingModal, 5000);
              }
              else {
                downloadStage.downloadError = 'downloadErrorText1';
              }
              break;
          case aboutSection.noDownloadAvailable.toString():
              downloadStage.downloadError = 'downloadErrorText2';
              break;
          case aboutSection.noDownloadAvailableAccount.toString():
              downloadStage.downloadError = 'downloadErrorText3';
              break;
          default:
              downloadStage.downloadError = 'downloadErrorText1';
              break;
      }
    } else {
      downloadStage.downloadError = 'downloadErrorText1';
    }

    downloadStage.downloadInitializing = false;
    this.props.handleDownloadModal(downloadStage);
  }


  closeSubmittingModal = () => {
    const downloadStage = {downloadModal: false, downloadError: null, downloadInitializing: false, downloadStarted: false };
    this.props.handleDownloadModal(downloadStage);
  }

  renderAnswers = (obj) => { //NOSONAR

    const openLinks = (link, text) => {
      if (typeof window['digitalData'] !== 'undefined') {
        window.digitalData.link = {
          linkName:
            typeof text === 'object'
              ? text?.target?.innerText + ' Link'
              : text + ' Link',
          linkType: 'About Section',
        };
      }

      AnalyticsService.trackEvent('link_click');
      window.open(link, '_blank');
    };

    let internalRoute = obj[0].isInternalRoute;
    return (

      <span
        className="link"
        id="privacy-link"
        onClick={internalRoute ? this.handleProductUpdateRedirect : openLinks.bind(
          this,
          obj[0].linkRef
        )}
      >{obj[0].linklabel}
      </span>);
  }

  renderAboutData = () => {
    let { aboutDetails } = this.props;
    return (
      <>
        {aboutDetails && aboutDetails.length > 0 && aboutDetails.map((ob) => {
          return (
            <div className="link-container" key={ob.id}>
              {this.renderAnswers(ob.data.links)}
              <hr className="separator" />
            </div>
          )
        })}
        <div></div>
      </>
    );
  }
  
  render = () => {
    localStorage.setItem('activeItem', 'Support');
    const {
      headingText,
      softwareText,
      softwareButtonText,
    } = this.props.aboutSection;

    let isLoading = this.props.isLoading;
    const { t } = this.props;
    
    return (
      <>
    {isLoading ? (
          <div></div>):(
      <div className="about-section-wrapper">
        <h3 className="about-heading">{headingText}</h3>
        {this.renderAboutData()}
        <div className="link-container">
        
            <span
              className="link"
              onClick={() =>
                this.props.handleManufactureDetailsClick(true, null)
              }
            >
              {t('deviceLabelInfo')}
              
            </span>
            <hr className="separator" />
         
     
        </div>
        <div className="meeting-software-container">
          <span className="text-container">{softwareText}</span>
          <PrimaryButton
            className={`secondary-btn secondary-btn--stroked-secondary`}
            text={softwareButtonText}
            onClick={this.handleDownloadPopUp}
          >
            <FontAwesomeIcon icon={'download'} />
          </PrimaryButton>
        </div>

        {this.props.support.downloadModal && (
          <DownloadInitialize
            downloadStarted={this.props.support.downloadStarted}
            downloadInitializing={this.props.support.downloadInitializing}
            downloadError={this.props.support.downloadError}
            retryDownload={this.handleDownloadPopUp}
            closeSubmittingModal={this.closeSubmittingModal}
          />
        )}

      </div>)}
      </>
    )

  };
}
export const About = withRouter(withTranslation()(AboutComponent));
export const AboutUnautherized = withRouter(AboutUnautherizedComponent);

class Support extends Component {
  constructor(props) {
    super(props);
    this.state = {
      manufactureDetailsModalVisible: false,
    };
    this.isAuthorized = this.props.isAuthorized;
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateAnalytics();
    if (this.props.isAuthorized) {
      this.props.loadSupportFaq();
      this.props.loadProductUpdate(this.props.subscription && this.props.subscription.subscriptionInfo.language ? this.props.subscription.subscriptionInfo.language:'English');
    }
    else {
      this.props.loadUnauthenticatedSupportFaq();
    }
  }

  updateAnalytics = () => {
    const category = window.location.href.replace(window.location.origin, '');
    const digitalData = {
      page: {
        pageInfo: {
          domain: document.domain,
          location: document.location,
          pageName: 'Support',
          siteSection: 'Support',
          pageURL: document.URL,
        },
        category: {
          primaryCategory: category.replace('/', ''),
          pageType: document.domain,
        },
      },
      user: {
        profile: {
          profileInfo: {
            loginStatus: 'logged in',
            profileID: this.props.subscription?.subscriptionInfo?.sfdcUserId,
          },
        },
      },
    };

    AnalyticsService.updateDigitalData(digitalData);
    AnalyticsService.trackEvent('setAnalyticsVariables');
    AnalyticsService.trackEvent('pageLoaded');
  };

  handleManufactureDetailsClick = (visible) => {
    this.setState({ manufactureDetailsModalVisible: visible });
  }

  handleClose = () => {
    this.setState(() => {
      return { manufactureDetailsModalVisible: false };
    });
   
  };

  renderAuthorizedUserData = () => {
    this.isAuthorized = this.props.isAuthorized;
    let { list } = this.props.support;
    let about = list.filter(function (el) {
      return el.type == 'links'
    });
    let newAbout = JSON.parse(JSON.stringify(about));
    this.translateSupporAboutLabels(newAbout);

    let manufactureDetails = list.filter(function (el) {
      return el.type == 'MANUFACTURE_DETAILS' 
    });
    
   let manufactureDetailsContent = manufactureDetails.length > 0 && manufactureDetails[0] ? manufactureDetails[0].data.htmlData : "";
   let { t } = this.props;
    let {version} = this.props.support.fieldValue;
    let version_no;
    if (manufactureDetails.length > 0 && this.isAuthorized) {
      if (version) 
        version_no = version.slice(8)
      else 
        version_no = ""
    } else {
      version_no = "";
    }

      return (
      <>
        {this.props.isAuthorized ? (
          <About
            aboutDetails={newAbout}
            aboutSection={supportPageConstants.aboutSection}
            collab={this.props.collab}
            fetchCollabConfig={this.props.getNativeAppConfig}
            productUpdates={this.props.support}
            isLoading = {this.props.support.isLoading}
            handleManufactureDetailsClick={this.handleManufactureDetailsClick}
            {...this.props}
          />
        ) : (
          <AboutUnautherized
            aboutDetails={newAbout}
            aboutSection={supportPageConstants.aboutSection}

          />
        )}
        {
          this.state.manufactureDetailsModalVisible && (
            <ModalGE
            onDismiss={()=> this.handleClose()}
            
            handleManufactureDetailsClick={this.handleManufactureDetailsClick}
            >
            <div className='manufactureDetails'>
             <div className='heading'>{t('Device Label')}</div> 
             {t('digitalExpert')}
              <div className='version'> {version}</div>
              <div className='manufacturer'>
              <img  className = 'manufacturer_Image' src={manufacturer}></img>
              <span className= 'manufacturer_Details'dangerouslySetInnerHTML={{ __html: manufactureDetailsContent }}></span>
              </div>
              <div className='batchcode'>
              <img className = 'batchcode_Image'src={batchcode}></img>
              <span className='batchcodeDetails'>{version_no}</span>
              </div>
             
              </div>
            </ModalGE>
           

          )
        }
      </>
    );
  };

  render() {
    const { pageHeading, faq, contactSection } =
      supportPageConstants;
    let { list, isLoading } = this.props.support;
    let { initialLoad } = this.props.generic;

      let contacts = list.filter(function (el) {
        return el.type == 'CONTACTS'
      });
      let newContacts = JSON.parse(JSON.stringify(contacts));
      this.translateSupporContactsLabels(newContacts);

      let contacts_extra = list.filter(function (el) {
        return el.type == 'CONTACTS_EXTRA'
      });
      let newContactsExtra = JSON.parse(JSON.stringify(contacts_extra));
      this.translateSupporContactsLabels(newContactsExtra);

      let qaList = list.filter(function (el) {
        return el.type == 'FAQ' 
      });

      let pageHead;
      if (this.props.isAuthorized) pageHead = (
          <h3 className="page-heading">{pageHeading}</h3>
        )
      else pageHead = (
          <h3 className="page-heading-unauth">{pageHeading}</h3>
        )

      let contactContent;
      if (this.isAuthorized) contactContent = <ContactUsAuthorised
          contacts={newContacts}
          contacts_extra={newContactsExtra}
          contactSection={contactSection}
          isLoading={this.props.support.isLoading}
        />
      else contactContent = <ContactUs
          contacts={newContacts}
          contactSection={contactSection}
          contacts_extra={newContactsExtra}
          isAuthorized={this.isAuthorized}
          isLoading={this.props.support.isLoading}
        />
   
    return (
      (isLoading || initialLoad) ? <div className = 'init-loader'><PulseLoader color={'#ffffff'} /></div>: <div className="support-page-wrapper">
        {pageHead}
       
        {<FAQ
            faq={faq}
            isLoading={this.props.support}
            support={qaList}
            isAuthorized={this.isAuthorized}
          />}
        {contactContent}
        {this.renderAuthorizedUserData()}
      </div>

    );
  }

  translateSupporContactsLabels = (listLabel) =>
  {
    const { t } = this.props;
    for (let i in listLabel)
    {
      if(listLabel[i].data.htmlData != ""){
        if(listLabel[i].data.htmlData.includes("QR")){
          const langArray = listLabel[i].data.htmlData.split("<");
          langArray[0] = t(langArray[0]);
          listLabel[i].data.htmlData = listLabel[i].data.htmlData.replace("QR Label", langArray[0]);
        }
        listLabel[i].data.htmlData = t(listLabel[i].data.htmlData);
      }

      if(listLabel[i].data.links[0].icon == "file-signature")
      {
        listLabel[i].data.links[0].linklabel = t(listLabel[i].data.links[0].linklabel);
      }
      listLabel[i].data.label = t(listLabel[i].data.label);
    }
  }

  translateSupporAboutLabels = (listLabel) =>
  {
    const { t } = this.props;
    for (let i in listLabel)
    {
        listLabel[i].data.links[0].linklabel = t(listLabel[i].data.links[0].linklabel);
    }
  }
}

export default withTranslation()(Support);
